import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import {
  GetOrderReturnEligibilityBatchRequest,
  type OrderReturnEligibilityItemDto,
  OrdersClient,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";

export const OrderReturnEligibilityQueryKeys = {
  ReturnEligibility: "ecommerce-order-return-eligibility",
} as const;

export default function useGetOrderReturnEligibility(
  biOrderIds: Array<number | null | undefined>,
  enabled: boolean,
) {
  const api = useApi(OrdersClient);
  const uniqueBiOrderIds = Array.from(
    new Set(biOrderIds.filter((biOrderId): biOrderId is number => biOrderId != null)),
  );

  const query = useQuery({
    queryKey: [OrderReturnEligibilityQueryKeys.ReturnEligibility, uniqueBiOrderIds],
    queryFn: async () => {
      const request = new GetOrderReturnEligibilityBatchRequest({
        biOrderIds: uniqueBiOrderIds,
      });

      return api.getReturnOrderEligibilityBatch(request);
    },
    enabled: enabled && uniqueBiOrderIds.length > 0,
    staleTime: ms("5m"),
  });

  const eligibilityByBiOrderId = (query.data ?? []).reduce<Record<number, boolean>>(
    (result: Record<number, boolean>, item: OrderReturnEligibilityItemDto) => {
      if (item.biOrderId != null) {
        result[item.biOrderId] = item.canReturn === true;
      }
      return result;
    },
    {},
  );

  return {
    eligibilityByBiOrderId,
    isLoading: query.isLoading,
  };
}